<h1 mat-dialog-title
  class="title draggable-dialogue-header"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle>
  Permissions for Role {{this.SelectedRole.name}}
</h1>

<div mat-dialog-content class="body" cdkTrapFocus>
  <mat-form-field appearance="fill" class="selected-role">
    <mat-label>Selected Role</mat-label>
    <mat-select [(value)]="this.SelectedRole" (selectionChange)="roleChanged($event.value)">
      @for (role of this.Roles; track role) {
        <mat-option [value]="role">{{role.name}}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="tables">
    <mat-tab-group class="permission-mat-tab-group">
      <mat-tab label="Workflow States">
        <div class="table-wrapper">
          <table #wfStatePermissionsTable mat-table [dataSource]="this.WorkflowStatePermissions">
            <ng-container matColumnDef="workflowEntityName">
              <th mat-header-cell
                *matHeaderCellDef
              class="workflow-entity-name-mat-header-cell">Workflow State</th>
              <td mat-cell
                *matCellDef="let permissionsRow"
              class="workflow-entity-name-mat-cell"> {{permissionsRow.stateName}} </td>
            </ng-container>
            <ng-container matColumnDef="permissions">
              <th mat-header-cell
                *matHeaderCellDef
                class="center-header">
                {{this.PermissionsHeader}}
              </th>
              <td mat-cell *matCellDef="let permissionsRow">
                <mat-checkbox class="first-mat-checkbox-in-row"
                  [(ngModel)]="permissionsRow.canView"
                (ngModelChange)="this.workflowStatePermissionChanged(permissionsRow,'View')">{{this.ViewText}}</mat-checkbox>
                <mat-checkbox class="first-mat-checkbox-in-row"
                  [(ngModel)]="permissionsRow.canEdit"
                (ngModelChange)="this.workflowStatePermissionChanged(permissionsRow,'Edit')">{{this.EditText}}</mat-checkbox>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="this.DisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: this.DisplayedColumns;"></tr>
          </table>
        </div>
      </mat-tab>

      <mat-tab label="Workflow Actions">
        <div class="table-wrapper">
          <table #wfStatePermissionsTable mat-table [dataSource]="this.TransitionPermissions">
            <ng-container matColumnDef="workflowEntityName">
              <th mat-header-cell
                class="workflow-entity-name-mat-header-cell"
              *matHeaderCellDef>Action</th>
              <td mat-cell
                *matCellDef="let transitionRow"
                class="workflow-entity-name-mat-cell">
                {{this.changeToDash(transitionRow.transitionName)}}
              </td>
            </ng-container>
            <ng-container matColumnDef="permissions">
              <th mat-header-cell
                *matHeaderCellDef
                class="workflow-transition-permissions-mat-header-cell">

                @if ((this.WorkflowStatePermissionCount > 1)) {
                  <mat-checkbox class="first-mat-checkbox-in-row"
                    [(ngModel)]="this.AllTransitionPermissionsCanEdit"
                  (change)="this.allWorkflowTransitionPermissionsChanged($event)">{{this.TransitionPermissionsAllCheckboxText}}</mat-checkbox>
                }

              </th>

              <td mat-cell
                *matCellDef="let transitionRow; let i=index"
                class="workflow-transition-permissions-mat-cell">
                <mat-checkbox class="first-mat-checkbox-in-row"
                  [(ngModel)]="transitionRow.canEdit"
                (ngModelChange)="this.workflowTransitionPermissionChanged(this.TransitionPermissions, 'View')"></mat-checkbox>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="this.TransitionPermissionsDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: this.TransitionPermissionsDisplayedColumns;"></tr>
          </table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-flat-button
    color="primary"
    class="theme-primary-btn"
    (click)="closeDialog(true)"
    [matTooltipPosition]="this.TooltipPosition"
  matTooltip="{{this.OkButtonTooltip}}">OK</button>

  <button mat-flat-button
    (click)="closeDialog()"
    [matTooltipPosition]="this.TooltipPosition"
  matTooltip="{{this.CancelButtonTooltip}}">Cancel</button>
</div>
